import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import {BenchlingAppsTable} from './MembersTable';
import {Member, MemberInfo} from './OrganizationConstants';

export default function OrganizationBenchlingAppMembersTab({
  organization,
  organizationBenchlingAppMembers,
  isCurrentUserMember,
  canManageRoles,
  userIdToMemberInfo,
}: {
  organization: {id: string};
  organizationBenchlingAppMembers: Array<Member> | null;
  isCurrentUserMember: boolean;
  canManageRoles: boolean;
  userIdToMemberInfo: {[userId: string]: MemberInfo} | null;
}): JSX.Element {
  if (!organizationBenchlingAppMembers || !userIdToMemberInfo) {
    return <CenteredHorizontalThrobber />;
  }

  return (
    <BenchlingAppsTable
      groupId={organization.id}
      groupType={ModelTypeConstants.ORGANIZATION}
      canManageRoles={canManageRoles}
      members={organizationBenchlingAppMembers}
      shouldShowMemberInfo={isCurrentUserMember || canManageRoles}
      userIdToMemberInfo={userIdToMemberInfo}
    />
  );
}
